import getValueReduxUtil from 'modules/redux/utils/get-value'
import { TRAINING_PLAN_KEY } from 'modules/training/models/plan/constants'

function getImagePlanUtil (instance) {
  return getValueReduxUtil(
    instance, TRAINING_PLAN_KEY.IMAGE
  )
}

export default getImagePlanUtil
